export enum PazaakHandSlots {
  INVALID = -1,
  SLOT_1 = 0,
  SLOT_2 = 1,
  SLOT_3 = 2,
  SLOT_4 = 3,
  MAX_SLOTS = 4
}
